/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_team = /** @type {(inputs: {}) => string} */ () => {
	return `Tým`
};

const da_attributes_team = /** @type {(inputs: {}) => string} */ () => {
	return `Hold`
};

const de_attributes_team = /** @type {(inputs: {}) => string} */ () => {
	return `Mannschaft`
};

const en_attributes_team = /** @type {(inputs: {}) => string} */ () => {
	return `Team`
};

const es_attributes_team = /** @type {(inputs: {}) => string} */ () => {
	return `Equipo`
};

const fr_attributes_team = /** @type {(inputs: {}) => string} */ () => {
	return `Équipe`
};

const hu_attributes_team = /** @type {(inputs: {}) => string} */ () => {
	return `Csapat`
};

const it_attributes_team = /** @type {(inputs: {}) => string} */ () => {
	return `Squadra`
};

const nl_attributes_team = /** @type {(inputs: {}) => string} */ () => {
	return `Team`
};

const pl_attributes_team = /** @type {(inputs: {}) => string} */ () => {
	return `Drużyna`
};

const pt_attributes_team = /** @type {(inputs: {}) => string} */ () => {
	return `Equipa`
};

const sv_attributes_team = /** @type {(inputs: {}) => string} */ () => {
	return `Team`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_team = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_team(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_team", locale)
	if (locale === "cs") return cs_attributes_team(inputs)
	if (locale === "da") return da_attributes_team(inputs)
	if (locale === "de") return de_attributes_team(inputs)
	if (locale === "en") return en_attributes_team(inputs)
	if (locale === "es") return es_attributes_team(inputs)
	if (locale === "fr") return fr_attributes_team(inputs)
	if (locale === "hu") return hu_attributes_team(inputs)
	if (locale === "it") return it_attributes_team(inputs)
	if (locale === "nl") return nl_attributes_team(inputs)
	if (locale === "pl") return pl_attributes_team(inputs)
	if (locale === "pt") return pt_attributes_team(inputs)
	return sv_attributes_team(inputs)
};
export { attributes_team as "attributes.team" }